import React, { useState } from "react";
import axiosInstance from "../api/axios";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Button, TextField, Typography, Alert } from "@mui/material";

const ResetPasswordForm = () => {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [passwordMatchError, setPasswordMatchError] = useState(false);
  const navigate = useNavigate();

  // עדכון הסיסמה החדשה
  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
    validatePasswordMatch(e.target.value, confirmPassword);
  };

  // עדכון אישור הסיסמה
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    validatePasswordMatch(newPassword, e.target.value);
  };

  // בדיקה אם הסיסמאות תואמות
  const validatePasswordMatch = (password, confirmPassword) => {
    setPasswordMatchError(password !== confirmPassword && confirmPassword !== "");
  };

  // טיפול בהגשת הטופס
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError("הסיסמאות אינן תואמות.");
      return;
    }

    try {
      await axiosInstance.post(`/users/reset-new-password`, {
        new_password: newPassword,
        token: token,
      });
      setMessage("איפוס הסיסמה בוצע בהצלחה! כעת ניתן להתחבר למערכת.");
      setError("");
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      setError("אירעה שגיאה באיפוס הסיסמה. אנא נסה שוב.");
      setMessage("");
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "400px",
        margin: "auto",
        mt: 5,
        p: 3,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        borderRadius: 2,
        backgroundColor: "#fff",
        textAlign: "center",
        direction: "rtl", // כיוון מימין לשמאל
      }}
    >
      <Typography variant="h4" gutterBottom>
        איפוס סיסמה
      </Typography>

      {message && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          type="password"
          label="סיסמה חדשה"
          value={newPassword}
          onChange={handleNewPasswordChange}
          required
          margin="normal"
          inputProps={{ style: { textAlign: "right" } }}
        />
        <TextField
          fullWidth
          type="password"
          label="אישור סיסמה חדשה"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange}
          required
          margin="normal"
          error={passwordMatchError}
          helperText={passwordMatchError ? "הסיסמאות אינן תואמות" : ""}
          inputProps={{ style: { textAlign: "right" } }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 2, backgroundColor: "#1976d2" }}
          disabled={passwordMatchError || !newPassword || !confirmPassword}
        >
          איפוס סיסמה
        </Button>
      </form>
    </Box>
  );
};

export default ResetPasswordForm;
